import type {Design} from "../_types/Design";
import type {Size} from "../_types/Size";
import {ObjectPipeline, ObjectPipelinePass} from "../pipeline/ObjectPipeline";
import {ColorObjectPass} from "../pipeline/passes/color/ColorObjectPass";
import {FillObjectPass} from "../pipeline/passes/fill/FillObjectPass";
import {RotateObjectPass} from "../pipeline/passes/RotateObjectPass";
import {ScaleObjectPass} from "../pipeline/passes/ScaleObjectPass";

export const getObjectPipelineFromDesign = (
    sceneSize: Size,
    design: Design
): ObjectPipeline => {

    const pipeline = new ObjectPipeline();

    for (const [propertyName, options] of Object.entries(design.properties)) {

        // we don't need to color the object when using color mode 'blur' or fill mode 'frame'
        if (propertyName === "color"
            && (design.properties.color?.mode === "blur"
                || design.properties.fill.mode === "frame")) {
            continue;
        }

        pipeline.addPass(
            getObjectPipelinePassFromPropertyName(propertyName, sceneSize, options));
    }

    return pipeline;
};

const propertyNameToObjectPipelinePasMap: Record<string, any> = {
    "fill": FillObjectPass,
    "scale": ScaleObjectPass,
    "rotate": RotateObjectPass,
    "color": ColorObjectPass
};

const getObjectPipelinePassFromPropertyName = (
    propertyName: string,
    sceneSize: Size,
    options: any
): ObjectPipelinePass => {

    const objectPipelinePass = propertyNameToObjectPipelinePasMap[propertyName];

    if (!objectPipelinePass) {
        throw new Error(`No particle pipeline pass for property '${propertyName}'`);
    }

    return new objectPipelinePass(sceneSize, options);
};